import { parseDate, useLocale } from '@mirai/locale';
import { Icon, Text, useDevice, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import * as style from './Input.module.css';
import { ICON } from '../../../helpers';

const ICON_PROPS = { className: style.icon };
const TEXT_PROPS = { action: true, medium: true };

const Context = ({ bookingId, checkIn, checkOut, adults, childrenAges = [] }) => {
  const { isMobile } = useDevice();
  const { dateFormat } = useLocale();

  const dateFormatCompact = { day: 'numeric', month: 'short', weekday: !isMobile ? 'short' : undefined };

  return bookingId || !!checkIn || adults > 0 ? (
    <View row className={style.context}>
      {bookingId && (
        <View row className={style.field}>
          <Icon {...ICON_PROPS} value={ICON.ASSIGNMENT} />
          <Text {...TEXT_PROPS}>{bookingId}</Text>
        </View>
      )}

      {!!checkIn && (
        <View row className={style.field}>
          <Icon {...ICON_PROPS} value={ICON.CALENDAR} />
          <Text {...TEXT_PROPS}>{dateFormat(parseDate(checkIn), dateFormatCompact)}</Text>
          {checkOut && <Text {...TEXT_PROPS}>{` — ${dateFormat(parseDate(checkOut), dateFormatCompact)}`}</Text>}
        </View>
      )}

      {adults > 0 && (
        <View row className={style.field}>
          <Icon {...ICON_PROPS} value={ICON.PEOPLE} />
          <Text {...TEXT_PROPS}>
            {adults} {childrenAges.length ? `+ ${childrenAges.length}` : ''}
          </Text>
        </View>
      )}
    </View>
  ) : null;
};

Context.propTypes = {
  bookingId: PropTypes.string,
  checkIn: PropTypes.string,
  checkOut: PropTypes.string,
  adults: PropTypes.number,
  childrenAges: PropTypes.arrayOf(PropTypes.number),
};

export { Context };
